let S = { clientId: "", environment: "sandbox", region: "default" }, y, D, I;
const N = (e) => {
  e && (S = { ...e });
}, w = () => S, v = (e) => {
  e && (y = { ...e });
}, P = () => y, R = (e) => {
  e && (D = e);
}, q = () => I, G = (e) => {
  e && (I = e);
}, i = () => D, L = () => {
  const { environment: e, region: t } = w(), s = e === "sandbox";
  var n = t === "default" ? "" : t || "";
  return n = n ? `${n}.` : "", s ? `api.sandbox.${n}sardine.ai` : `api.${n}sardine.ai`;
}, k = (e) => {
  N(e);
}, z = async (e) => new Promise(function(t, s) {
  var C;
  const { clientId: n, environment: B, region: T, apiSubdomain: r, pixelSubdomain: h } = w();
  if (!n) {
    s({
      status: "error",
      error: new Error("clientId is required")
    });
    return;
  }
  const a = i(), {
    customerId: c,
    sessionKey: d,
    flow: u,
    fields: f,
    enableBiometrics: g,
    enableGeoLocation: l,
    enablePortScanning: b,
    parentSessionKey: p,
    partnerId: x
  } = e;
  if (a && !g && !l && !b && !p && !x)
    a.updateConfig({ flow: u, userIdHash: c, sessionKey: d, fields: f }), v(e), t({ status: "success" });
  else {
    const $ = B === "sandbox";
    var E = L();
    const H = r || E;
    var o = document.createElement("script");
    o.type = "text/javascript", o.async = !0, o.src = `https://${H}/assets/loader.min.js`, o.onload = function() {
      const j = window._Sardine.createContext({
        clientId: n,
        sessionKey: d,
        userIdHash: c,
        flow: u || location.pathname,
        environment: $ ? "sandbox" : "production",
        parentElement: document.body,
        partnerId: x,
        parentSessionKey: p,
        enablePortScanning: b,
        enableBiometrics: g || !0,
        enableGeoLocation: l,
        apiSubdomain: r,
        pixelSubdomain: h,
        fields: f,
        onDeviceResponse: function(K) {
          G(K), t({ status: "success" });
        }
      });
      v(e), R(j);
    };
    var m = document.getElementsByTagName("script")[0];
    (C = m.parentNode) == null || C.insertBefore(o, m);
  }
}), A = () => P(), F = () => q(), J = () => {
  const e = i();
  return e ? (e.unbind(), !0) : !1;
}, M = () => {
  const e = i();
  return e ? (e.bind(), !0) : !1;
};
export {
  M as bind,
  F as getDeviceResponse,
  A as getSardineConfig,
  k as setupSardine,
  J as unbind,
  z as updateSardineConfig
};
//# sourceMappingURL=index.es.js.map
